var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanProductsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H18V20C17.9993 19.8684 18.0245 19.7379 18.0742 19.6161C18.124 19.4943 18.1973 19.3834 18.29 19.29L22 15.59V6C22 5.73478 21.8946 5.48044 21.7071 5.29291C21.5196 5.10537 21.2652 5 21 5C20.7348 5 20.4804 5.10537 20.2929 5.29291C20.1054 5.48044 20 5.73478 20 6V11H18V6C18 5.20435 18.3161 4.4413 18.8787 3.87869C19.4413 3.31608 20.2044 3 21 3C21.7957 3 22.5587 3.31608 23.1213 3.87869C23.6839 4.4413 24 5.20435 24 6V16C23.9995 16.1323 23.9727 16.2632 23.9212 16.3851C23.8697 16.5069 23.7945 16.6174 23.7 16.71L20 20.41V22Z",
    fill: "url(#paint0_linear_3151_4948)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.9999H13V14.0899C12.9993 13.9583 13.0245 13.8278 13.0742 13.706C13.124 13.5842 13.1973 13.4734 13.29 13.3799L15.79 10.8799C16.3623 10.3369 17.1211 10.0342 17.91 10.0342C18.6989 10.0342 19.4577 10.3369 20.03 10.8799C20.5918 11.4424 20.9074 12.2049 20.9074 12.9999C20.9074 13.7949 20.5918 14.5574 20.03 15.1199L18.53 16.6199L17.12 15.2099L18.62 13.7099C18.7137 13.6169 18.7881 13.5064 18.8389 13.3845C18.8897 13.2626 18.9158 13.1319 18.9158 12.9999C18.9158 12.8679 18.8897 12.7372 18.8389 12.6153C18.7881 12.4935 18.7137 12.3829 18.62 12.2899C18.527 12.1962 18.4165 12.1218 18.2946 12.071C18.1727 12.0202 18.042 11.9941 17.91 11.9941C17.778 11.9941 17.6473 12.0202 17.5254 12.071C17.4036 12.1218 17.293 12.1962 17.2 12.2899L15 14.4999V21.9999Z",
    fill: "url(#paint1_linear_3151_4948)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9897 24H19.9897V23H14.9897V24H12.9897V21H21.9897V24Z",
    fill: "url(#paint2_linear_3151_4948)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91002 22H3.91002V20.41L0.280017 16.7C0.0989317 16.5121 -0.00154941 16.2609 1.80672e-05 16V6C1.80672e-05 5.20435 0.316071 4.4413 0.87868 3.87869C1.44129 3.31608 2.20437 3 3.00002 3C3.79567 3 4.55872 3.31608 5.12133 3.87869C5.68393 4.4413 6.00002 5.20435 6.00002 6V11H4.00002V6C4.00002 5.73478 3.89465 5.48044 3.70711 5.29291C3.51957 5.10537 3.26523 5 3.00002 5C2.7348 5 2.48043 5.10537 2.2929 5.29291C2.10536 5.48044 2.00002 5.73478 2.00002 6V15.59L5.62001 19.3C5.8011 19.4879 5.90158 19.7391 5.90001 20L5.91002 22Z",
    fill: "url(#paint3_linear_3151_4948)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 21.9995H8.99982V14.5095L6.71982 12.2995C6.62669 12.2043 6.51545 12.1286 6.39267 12.0769C6.26989 12.0252 6.13803 11.9986 6.00482 11.9986C5.87161 11.9986 5.73973 12.0252 5.61694 12.0769C5.49416 12.1286 5.38296 12.2043 5.28983 12.2995C5.1961 12.3925 5.12169 12.5031 5.07092 12.6249C5.02015 12.7468 4.99402 12.8775 4.99402 13.0095C4.99402 13.1415 5.02015 13.2722 5.07092 13.3941C5.12169 13.5159 5.1961 13.6265 5.28983 13.7195L6.78983 15.2195L5.37982 16.6295L3.87982 15.1295C3.31802 14.567 3.00244 13.8045 3.00244 13.0095C3.00244 12.2145 3.31802 11.452 3.87982 10.8895C4.44976 10.342 5.20946 10.0361 5.99982 10.0361C6.79017 10.0361 7.54987 10.342 8.11981 10.8895L10.6898 13.3795C10.7873 13.4725 10.865 13.5841 10.9183 13.7079C10.9716 13.8316 10.9993 13.9648 10.9998 14.0995V21.9995Z",
    fill: "url(#paint4_linear_3151_4948)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9897 24H8.98965V23H3.90967V24H1.90967V21H10.9897V24Z",
    fill: "url(#paint5_linear_3151_4948)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5H11C10.4696 5 9.96086 5.21071 9.58578 5.58578C9.21071 5.96086 9 6.46957 9 7V9H15V7C15 6.46957 14.7893 5.96086 14.4142 5.58578C14.0391 5.21071 13.5304 5 13 5Z",
    fill: "url(#paint6_linear_3151_4948)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9897 4C13.0943 4 13.9897 3.10457 13.9897 2C13.9897 0.89543 13.0943 0 11.9897 0C10.8852 0 9.98975 0.89543 9.98975 2C9.98975 3.10457 10.8852 4 11.9897 4Z",
    fill: "url(#paint7_linear_3151_4948)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4948",
    x1: 21,
    y1: 23.7593,
    x2: 21,
    y2: 0.537036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3151_4948",
    x1: 16.9537,
    y1: 23.1078,
    x2: 16.9537,
    y2: 8.48307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3151_4948",
    x1: 17.4897,
    y1: 24.2778,
    x2: 17.4897,
    y2: 20.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3151_4948",
    x1: 3.00001,
    y1: 23.7593,
    x2: 3.00001,
    y2: 0.537036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3151_4948",
    x1: 7.00113,
    y1: 23.1072,
    x2: 7.00113,
    y2: 8.48532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3151_4948",
    x1: 6.44966,
    y1: 24.2778,
    x2: 6.44966,
    y2: 20.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3151_4948",
    x1: 12,
    y1: 9.37037,
    x2: 12,
    y2: 4.48148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3151_4948",
    x1: 11.9897,
    y1: 4.37037,
    x2: 11.9897,
    y2: -0.518519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanProductsActive);
export default __webpack_public_path__ + "static/media/loan-products-active.18c5e035a1eb52187c89ad749d940131.svg";
export { ForwardRef as ReactComponent };